let ws;

export function connect(setIncomingMessages, login, password) {
  let disposed = false;
  let reconnectTimer;
  let socket;
  let delay = 250;
  const open = () => {
    if (disposed) return;
    document.cookie = `X-Authorization={"Login":"${login}", "Password":"${password}"}; path=/`;
    socket = new WebSocket(
      `wss://${
        document.location.host === 'localhost:3000'
          ? 'dev.a.is.mv1f.ru'
          : document.location.host
      }/api/mct-endpoint`
    );
    ws = socket;
    socket.onopen = () => {
      delay = 250;
    };
    socket.onmessage = (event) => {
      if (!disposed) setIncomingMessages(JSON.parse(event.data));
    };
    socket.onclose = (event) => {
      if (!disposed && !event.wasClean) {
        reconnectTimer = setTimeout(open, delay);
        delay = Math.min(delay + 250, 10000);
      }
    };
  };
  open();
  return () => {
    disposed = true;
    clearTimeout(reconnectTimer);
    socket.close();
  };
}

export function sendMessage(data) {
  ws.send(JSON.stringify(data));
}
